module.exports = __webpack_public_path__ + "static/media/graphIcon.da0a68f4.svg";